export const JobTableColumns = [
  // { key: 'sn', label: 'SN' },
  { key: 'action', label: 'Action' },
  { key: 'jobId', label: 'Job #' },
  { key: 'custId', label: 'Cust #' },
  { key: 'customerName', label: 'Customer' },
  { key: 'siteName', label: 'Site' },
  { key: 'stateName', label: 'State' },
  { key: 'cityName', label: 'City' },
];
